/**
 * DrilldownLayout — sidebar list of named sections + a detail panel for the
 * selected one. Same sidebar/detail shape as the Programs drilldown view,
 * generalized for any fixed list of sections (not just data rows).
 *
 * Props:
 *   sections     — [{ key, label, description?, content }]
 *   selectedKey  — currently selected section's key
 *   onSelect     — called with a section's key when clicked
 *   sidebarLabel — header text above the section list (optional)
 *   sidebarWidth — px width of the sidebar (default 260)
 *   minHeight    — px min-height of the whole layout (default 500)
 */
export default function DrilldownLayout({ sections, selectedKey, onSelect, sidebarLabel, sidebarWidth = 260, minHeight = 500 }) {
  const selected = sections.find(s => s.key === selectedKey) || sections[0];

  return (
    <div style={{ display: 'flex', gap: '20px', minHeight }}>
      <div style={{ width: sidebarWidth, flexShrink: 0, background: 'white', border: '1px solid #e8ecef', borderRadius: '8px', overflow: 'hidden', alignSelf: 'flex-start' }}>
        {sidebarLabel && (
          <div style={{ padding: '12px 16px', borderBottom: '1px solid #eee', background: '#f5f5f5', fontSize: '13px', fontWeight: '600', color: '#555' }}>
            {sidebarLabel}
          </div>
        )}
        {sections.map(s => (
          <div key={s.key} onClick={() => onSelect(s.key)}
            style={{ padding: '10px 16px', borderBottom: '1px solid #f0f0f0', cursor: 'pointer', background: selectedKey === s.key ? '#ebf5fb' : 'white' }}
            onMouseEnter={e => { if (selectedKey !== s.key) e.currentTarget.style.background = '#f8f9fa'; }}
            onMouseLeave={e => { if (selectedKey !== s.key) e.currentTarget.style.background = 'white'; }}
          >
            <div style={{ fontSize: '13px', fontWeight: '500', color: '#2c3e50' }}>{s.label}</div>
            {s.description && <div style={{ fontSize: '11px', color: '#888', marginTop: '2px' }}>{s.description}</div>}
          </div>
        ))}
      </div>

      <div style={{ flex: 1, background: 'white', border: '1px solid #e8ecef', borderRadius: '8px', padding: '20px', minWidth: 0 }}>
        {selected?.content}
      </div>
    </div>
  );
}
